export const TRANSPOREON_PRODUCT_NAME = 'Transporeon Visibility';
export const TRIMBLE_PRODUCT_NAME = 'Trimble Freight Visibility';
export const TRANSPOREON_THEME = 'transporeon-light';
export const TRIMBLE_THEME = 'trimble-light';
